import React from "react";
import { RolePermissionForm } from "./RolePermissionForm";

// Edit Role opens as a side panel over the Roles list (expandable to a full
// view), the same way Add Role does. It shares its layout and permission
// logic with Create Role -- see RolePermissionForm.js.
// initialExpanded: open straight in the full view (Edit clicked from an
// expanded View Role).
export const EditPermissionRole = ({
  editRoleDetails,
  onClose,
  onSaved,
  initialExpanded = false,
  onExpandedChange,
}) => (
  <RolePermissionForm
    mode="edit"
    variant="panel"
    initialExpanded={initialExpanded}
    onExpandedChange={onExpandedChange}
    roleDetails={editRoleDetails}
    onClose={onClose}
    onSaved={onSaved}
  />
);
